import * as React from 'react';
import styled from 'styled-components';
export var IconButtonsGroup = function IconButtonsGroup(_ref) {
  var maxColumns = _ref.maxColumns,
    options = _ref.options,
    selected = _ref.selected,
    disabled = _ref.disabled,
    onToggle = _ref.onToggle;
  var handleToggle = function handleToggle(id) {
    if (disabled !== null && disabled !== void 0 && disabled.includes(id)) return;
    onToggle(id);
  };
  return /*#__PURE__*/React.createElement(StyledGroup, null, options.map(function (_ref2) {
    var id = _ref2.id,
      icon = _ref2.icon,
      title = _ref2.title,
      subLabel = _ref2.subLabel;
    var isDisabled = !!(disabled !== null && disabled !== void 0 && disabled.includes(id));
    return /*#__PURE__*/React.createElement(ButtonWrapper, {
      key: id,
      $maxColumns: maxColumns,
      className: selected.includes(id) ? 'selected' : '',
      onClick: function onClick() {
        return handleToggle(id);
      },
      disabled: isDisabled
    }, /*#__PURE__*/React.createElement(ToggleButton, {
      key: id,
      value: id,
      disabled: isDisabled,
      "aria-label": title
    }, icon), !!title && /*#__PURE__*/React.createElement(TitleContainer, {
      disabled: isDisabled
    }, title), !!subLabel && /*#__PURE__*/React.createElement(SubLabelContainer, {
      disabled: isDisabled
    }, subLabel));
  }));
};
var TitleContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "IconButtonsGroup__TitleContainer",
  componentId: "sc-f84woh-0"
})(["", ";font-size:", ";font-weight:", ";text-align:center;width:100%;&[disabled]{color:", ";}"], function (props) {
  return props.theme.mixins.margin({
    top: 1
  });
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.commons.font.sizes.small;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.commons.font.weights.bold;
}, function (props) {
  return props.theme.commons.colors.gray200;
});
var SubLabelContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "IconButtonsGroup__SubLabelContainer",
  componentId: "sc-f84woh-1"
})(["color:", ";", ";font-size:", ";text-align:center;width:100%;&[disabled]{color:", ";}"], function (props) {
  return props.theme.commons.colors.gray300;
}, function (props) {
  return props.theme.mixins.padding({
    top: 1
  });
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.commons.font.sizes.small;
}, function (props) {
  return props.theme.commons.colors.gray200;
});
var ToggleButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "IconButtonsGroup__ToggleButton",
  componentId: "sc-f84woh-2"
})(["background-color:transparent;border:1px solid ", ";", ";", ";line-height:0;&[disabled]{cursor:default;color:", ";background-color:", ";border:1px solid transparent;}"], function (props) {
  return props.theme.commons.colors.gray100;
}, function (props) {
  return props.theme.mixins.padding({
    ver: 2,
    hor: 2
  });
}, function (props) {
  return props.theme.mixins.borderRadius('circle');
}, function (props) {
  return props.theme.commons.colors.gray200;
}, function (props) {
  return props.theme.commons.colors.gray50;
});
var ButtonWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "IconButtonsGroup__ButtonWrapper",
  componentId: "sc-f84woh-3"
})(["display:flex;width:", ";max-width:", ";flex-grow:1;flex-direction:column;justify-content:flex-start;align-items:center;opacity:", ";", ";&:hover:not([disabled]){cursor:pointer;& ", "{color:", ";border:1px solid ", ";cursor:pointer;}& ", "{color:", ";}}&.selected{& ", "{color:", ";&[disabled]{color:", ";}}& ", "{color:", ";background-color:", ";border:1px solid transparent;&[disabled]{color:", ";background-color:", ";border:1px solid transparent;}}}"], function (props) {
  return "".concat(100 / props.$maxColumns, "%");
}, function (props) {
  return "".concat(100 / props.$maxColumns, "%");
}, function (props) {
  return props.disabled ? 0.6 : 1;
}, function (props) {
  return props.theme.mixins.margin({
    bottom: 1.5
  });
}, ToggleButton, function (props) {
  return props.theme.commons.colors.primary400;
}, function (props) {
  return props.theme.commons.colors.primary400;
}, TitleContainer, function (props) {
  return props.theme.commons.colors.primary400;
}, TitleContainer, function (props) {
  return props.theme.commons.colors.primary400;
}, function (props) {
  return props.theme.commons.colors.gray200;
}, ToggleButton, function (props) {
  return props.theme.commons.colors.primary400;
}, function (props) {
  return props.theme.commons.colors.primary50;
}, function (props) {
  return props.theme.commons.colors.gray200;
}, function (props) {
  return props.theme.commons.colors.gray50;
});
var StyledGroup = /*#__PURE__*/styled.div.withConfig({
  displayName: "IconButtonsGroup__StyledGroup",
  componentId: "sc-f84woh-4"
})(["display:flex;flex-wrap:wrap;justify-content:space-between;"]);